import { SetState, GetState } from 'zustand';
import { IScheduleCData } from '../types';

export interface IScheduleCSlice {
  currentScheduleCData: IScheduleCData,
  setCurrentScheduleCData: (data: IScheduleCData) => void;
  getCurrentScheduleCData: () => IScheduleCData,
  resetScheduleCDataSlice: () => void;
}

const createScheduleCDataSlice = (set: SetState<IScheduleCSlice>, get: GetState<IScheduleCSlice>) => ({
  currentScheduleCData: {
    scheduleCs: [],
  },
  resetScheduleCDataSlice: () => {
    set({
      currentScheduleCData: {
        scheduleCs: [],
      },
    });
  },
  setCurrentScheduleCData: (data: IScheduleCData) => {
    set({ currentScheduleCData: data });
  },
  getCurrentScheduleCData: () => get().currentScheduleCData,
});
export default createScheduleCDataSlice;
